import { SET_COUPON_VERIFY_ITEM } from '../../constants';
import * as Immutable from 'immutable';
const params = {
    verifyItem: null
};
const initialState = Immutable.fromJS(params);

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
export function coupon(state = initialState, action) {
    switch (action.type) {
        case SET_COUPON_VERIFY_ITEM:
            return state.merge({ verifyItem: action.data });
        default:
            return state;
    }
}
